// Unified Object Actions

// Get objects
export const getObjects = (payload) => ({
  payload,
  type: 'GET_OBJECTS',
});

export const setObjects = (payload) => ({
  payload,
  type: 'SET_OBJECTS'
});

// Create object
export const createObject = (payload) => ({
  payload,
  type: 'CREATE_OBJECT',
});

// Update object
export const updateObject = (payload) => ({
  payload,
  type: 'UPDATE_OBJECT',
});

// Bulk update objects
export const bulkUpdateObjects = (payload) => ({
  payload,
  type: 'BULK_UPDATE_OBJECTS',
});

// Bulk delete objects
export const bulkDeleteObjects = (payload) => ({
  payload,
  type: 'BULK_DELETE_OBJECTS',
});

export const bulkVerifyEmails = (payload) => ({
  payload,
  type: 'BULK_VERIFY_EMAILS',
});

// Delete single object
export const deleteObject = (payload) => ({
  payload,
  type: 'DELETE_OBJECT',
});

// Search objects
export const searchObjects = (payload) => ({
  payload,
  type: 'SEARCH_OBJECTS',
});

export const setSearchResults = (payload) => ({
  payload,
  type: 'SET_SEARCH_RESULTS',
});

// Loading states
export const setObjectsLoading = (payload) => ({
  payload,
  type: 'SET_OBJECTS_LOADING',
});

// Error handling
export const setObjectsError = (payload) => ({
  payload,
  type: 'SET_OBJECTS_ERROR',
});

// Properties management
export const getProperties = () => ({
  type: 'GET_PROPERTIES'
});

export const setProperties = (payload) => ({
  payload,
  type: 'SET_PROPERTIES',
});

export const createProperty = (payload) => ({
  payload,
  type: 'CREATE_PROPERTY',
});

export const updateProperty = (payload) => ({
  payload,
  type: 'UPDATE_PROPERTY',
});

export const deleteProperty = (payload) => ({
  payload,
  type: 'DELETE_PROPERTY',
});

// Views management
export const getViews = (payload) => ({
  payload,
  type: 'GET_VIEWS',
});

export const setViews = (payload) => ({
  payload,
  type: 'SET_VIEWS',
});

export const getOrCreateDefaultView = (payload) => ({
  payload,
  type: 'GET_OR_CREATE_DEFAULT_VIEW',
});

export const setDefaultView = (payload) => ({
  payload,
  type: 'SET_DEFAULT_VIEW',
});

export const createView = (payload) => ({
  payload,
  type: 'CREATE_VIEW',
});

export const updateView = (payload) => ({
  payload,
  type: 'UPDATE_VIEW',
});

export const deleteView = (payload) => ({
  payload,
  type: 'DELETE_VIEW',
});

// Import/Export management
export const toggleImportWizard = (data) => ({
  type: 'TOGGLE_IMPORT_WIZARD',
  payload: data
});

export const uploadImportFile = (payload) => ({
  payload,
  type: 'UPLOAD_IMPORT_FILE',
});

export const setImportPreview = (payload) => ({
  payload,
  type: 'SET_IMPORT_PREVIEW',
});

export const executeImport = (payload) => ({
  payload,
  type: 'EXECUTE_IMPORT',
});

export const getImportStatus = (payload) => ({
  payload,
  type: 'GET_IMPORT_STATUS',
});

export const setImportStatus = (payload) => ({
  payload,
  type: 'SET_IMPORT_STATUS',
});

export const getImportRows = (payload) => ({
  payload,
  type: 'GET_IMPORT_ROWS',
});

export const getImportHistory = (payload) => ({
  payload,
  type: 'GET_IMPORT_HISTORY',
});

export const setImportHistory = (payload) => ({
  payload,
  type: 'SET_IMPORT_HISTORY',
});

export const clearImportData = (payload) => ({
  payload,
  type: 'CLEAR_IMPORT_DATA',
});

export const rollbackImport = (payload) => ({
  payload,
  type: 'ROLLBACK_IMPORT',
});

export const validateImportData = (payload) => ({
  payload,
  type: 'VALIDATE_IMPORT_DATA',
});

export const getTemplateCSV = (payload) => ({
  payload,
  type: 'GET_TEMPLATE_CSV',
});

// Export management
export const toggleExportWizard = (data) => ({
  type: 'TOGGLE_EXPORT_WIZARD',
  payload: data
});

export const initiateExport = (payload) => ({
  payload,
  type: 'INITIATE_EXPORT',
});

export const setExportPreview = (payload) => ({
  payload,
  type: 'SET_EXPORT_PREVIEW',
});

export const executeExport = (payload) => ({
  payload,
  type: 'EXECUTE_EXPORT',
});

export const getExportStatus = (payload) => ({
  payload,
  type: 'GET_EXPORT_STATUS',
});

export const setExportStatus = (payload) => ({
  payload,
  type: 'SET_EXPORT_STATUS',
});

export const downloadExport = (payload) => ({
  payload,
  type: 'DOWNLOAD_EXPORT',
});

export const getExportHistory = (payload) => ({
  payload,
  type: 'GET_EXPORT_HISTORY',
});

export const setExportHistory = (payload) => ({
  payload,
  type: 'SET_EXPORT_HISTORY',
});

export const clearExportData = (payload) => ({
  payload,
  type: 'CLEAR_EXPORT_DATA',
});

// Filters management
export const applyFilters = (payload) => ({
  payload,
  type: 'APPLY_FILTERS',
});

export const setFilters = (payload) => ({
  payload,
  type: 'SET_FILTERS',
});

export const setQuickFilters = (payload) => ({
  payload,
  type: 'SET_QUICK_FILTERS',
});

export const setFilter = (payload) => ({
  payload,
  type: 'SET_FILTER',
});

export const clearFilters = (payload) => ({
  payload,
  type: 'CLEAR_FILTERS',
});

// Tags management
export const bulkUpdateObjectTags = (payload) => ({
  payload,
  type: 'BULK_UPDATE_OBJECT_TAGS'
});

export const updateTagGlobally = (payload) => ({
  payload,
  type: 'UPDATE_TAG_GLOBALLY'
});

export const deleteTagGlobally = (payload) => ({
  payload,
  type: 'DELETE_TAG_GLOBALLY'
});

export const createTag = (payload) => ({
  payload,
  type: 'CREATE_TAG'
});

